// slugify is still used across admin forms for slug generation.
// Category/room/style/material/collection/festival lists now come from the
// database via /api/taxonomy or /api/categories — never hardcode them here again.
export const slugify = (t) =>
  t.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');